import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import Theme from 'styles/theme';

const UnorderedList = ({ children, className, ...props }) => {
  const classes = classNames('UnorderedList', className);

  return (
    <ul className={classes} {...props}>
      {children}
      <style jsx>
        {`
          .UnorderedList {
            list-style: inside disc;
            padding-left: ${Theme.get('spacing') * 3}px;
            margin: 0;
            list-style: outside disc;
          }
        `}
      </style>
    </ul>
  );
};

UnorderedList.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  className: PropTypes.string,
};

UnorderedList.defaultProps = {
  className: '',
};

export default UnorderedList;
